import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { enumMapper, LicenseErrorCode, ROBOT_STATE_FILTER, RobotHostingType, RobotState, } from '@models';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { SessionsService, SignalRService, } from '@services';
import { of } from 'rxjs';
import { map, takeUntil, } from 'rxjs/operators';
// since we get the selected Robot Ids from the server, we'll overwrite the sessionId
var mapRobotIdToSessionId = function (source) { return ({
    total: source.total,
    data: source.data.map(function (e) {
        return (tslib_1.__assign({}, e, { sessionId: e.id, id: e.robot.id }));
    }),
}); };
var ɵ0 = mapRobotIdToSessionId;
var ProcessRobotsSource = /** @class */ (function () {
    function ProcessRobotsSource(_sessionService) {
        this._sessionService = _sessionService;
    }
    Object.defineProperty(ProcessRobotsSource.prototype, "mapper", {
        get: function () {
            return this._sessionService.mapper;
        },
        enumerable: true,
        configurable: true
    });
    ProcessRobotsSource.prototype.get = function (qo) {
        return !this.environmentId ?
            of({ data: [], total: 0 }) :
            this._sessionService
                .getSessionsForEnvironment(this.environmentId, qo)
                .pipe(map(mapRobotIdToSessionId));
    };
    return ProcessRobotsSource;
}());
export { ProcessRobotsSource };
var ProcessRobotsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ProcessRobotsGridComponent, _super);
    function ProcessRobotsGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.RobotHostingType = RobotHostingType;
        _this.LicenseErrorCode = LicenseErrorCode;
        _this.virtualScroll = false;
        _this.isJobsGrid = true;
        _this.selectionChange = new EventEmitter();
        _this.stateList = enumMapper(RobotState, {
            resourceKey: 'RobotState',
            filterValueMap: ROBOT_STATE_FILTER,
        });
        _this._signalRService = _this._injector.get(SignalRService);
        _this.clearSelection = function () {
            return _this._grid.selectionManager.clear();
        };
        _this._updateJobState = function (update) {
            var rowToPatch = _this._grid.dataManager.data$.value.find(function (robot) { return robot.sessionId === update.id; });
            if (!rowToPatch) {
                return;
            }
            _this._grid.dataManager
                .patchRow(rowToPatch.id, {
                state: update.state,
            });
        };
        return _this;
    }
    Object.defineProperty(ProcessRobotsGridComponent.prototype, "environmentId", {
        set: function (value) {
            var svc = this._service;
            svc.environmentId = value;
            this.clearSelection();
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcessRobotsGridComponent.prototype, "selectionFormControl", {
        get: function () {
            return this._selectionFormControl;
        },
        set: function (selectionFormControl) {
            this._selectionFormControl = selectionFormControl;
            this.selectedRobots = selectionFormControl.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcessRobotsGridComponent.prototype, "selectedRobots", {
        get: function () {
            return this._grid.selectionManager.selected || [];
        },
        set: function (robots) {
            var _a;
            (_a = this._grid.selectionManager).select.apply(_a, robots);
        },
        enumerable: true,
        configurable: true
    });
    ProcessRobotsGridComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._grid
            .selectionManager
            .changed$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function () {
            _this.selectionChange.next(_this._grid.selectionManager.selected.length);
            if (_this._selectionFormControl) {
                _this._selectionFormControl.setValue(_this._grid.selectionManager.selected.slice());
                _this._selectionFormControl.markAsDirty();
            }
        });
        if (!this.isJobsGrid) {
            return;
        }
        this.data$.pipe(takeUntil(this._destroyed$)).subscribe(function (data) {
            return _this._signalRService
                .watchRobots(data.map(function (robot) { return robot.id; }));
        });
        this._signalRService
            .sessions$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(this._updateJobState);
    };
    ProcessRobotsGridComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._signalRService.watchRobots(false);
    };
    return ProcessRobotsGridComponent;
}(ODataGridComponent));
export { ProcessRobotsGridComponent };
export { ɵ0 };
